module.exports = __webpack_public_path__ + "img/女孩+糖果.547700d6.png";